import React, { FunctionComponent } from 'react';
import { SbBlokData } from '@storyblok/react';
import classnames from 'classnames';

import { FontWeight, MediaBlock11, TextColors } from '@savebetter/components';

import { MediaProps } from './Media';
import { PageSectionBlok, PageSectionProps } from './PageSection';
import { Section } from './Section';

interface ContentBlock extends SbBlokData {
  media: MediaProps[];
  title: string;
  text: string;
}

interface Blok extends PageSectionBlok {
  contentBlocks: ContentBlock[];
  backgroundColor?: string;
  textColor?: TextColors;
  titleFontWeight?: FontWeight;
}

interface MediaSection5Props extends PageSectionProps {
  blok: Blok;
}

export const MediaSection5: FunctionComponent<React.PropsWithChildren<MediaSection5Props>> = ({ blok }) => {
  const {
    hasBackground,
    hasBorder,
    contentBlocks = [],
    hasPaddingBottom,
    hasPaddingTop,
    backgroundColor = '',
    textColor,
    titleFontWeight = 'font-bold'
  } = blok;
  return (
    <Section
      width="md"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      className={classnames({
        [backgroundColor]: !hasBackground
      })}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      <MediaBlock11 columnItems={contentBlocks} textColor={textColor} titleFontWeight={titleFontWeight}></MediaBlock11>
    </Section>
  );
};
